module.exports = __webpack_public_path__ + "media/Review-Some-Names.010cb62e.mp4";